export default {
  message: {
    "error": "오류가 발생했습니다!",
    "Sorrysomeerrorsoccurred": "죄송합니다, 일부 오류가 발생했습니다",
    "quit": "종료",
    "language": "언어",
    "Youcanchangethelanguagehere": "여기에서 언어를 변경할 수 있습니다!",
    "current": "현재",
    "home": "홈",
    "friends": "친구",
    "wallet": "지갑",
    "aboutus": "회사 소개",
    "Sharewithfriends": "친구와 공유하기",
    "copyFailure": "복사 실패",
    "copySuccess": "복사 성공",
    "Claimreward": "보상받기",
    "DailyLogin": "일일 로그인",
    "noInvitationsYet": "아직 초대가 없습니다",
    "LoadMore": "더 불러오기",
    "WatchAD": "광고 보기",
    "continue": "계속하기",
    "Congratulations": "축하합니다",
    "MyFriends": "내 친구들",
    "Invitefriends": "친구 초대하기",
    "Invitepremiumfriends": "프리미엄 친구 초대하기",
    "DailyTasks": "일일 작업",
    "inviteDesc": "초대하는 친구당 +{num} ${name}",
    "DailyTasksDesc": "작업을 완료하여 더 많은 ${name}을 얻으세요",
    "SponsorsandPartners": "스폰서 및 파트너",
    "Receivingwallet": "수신 지갑",
    "Enterwalletaddress": "{name} 지갑 주소 입력",
    "Claim": "보상받기",
    "Booster": "부스터",
    "RentPeriod": "임대 기간",
    "days30": "30일",
    "days": "일",
    "Dailyprofit": "일일 수익",
    "Totalprofit": "총 수익",
    "Quantity": "수량",
    "RentPrice": "임대 가격",
    "RentMiner": "채굴기 임대",
    "Insufficient": "불충분한 ${name}",
    "InsufficientMsg": "{num} ${name1} 필요, 친구를 초대하거나 작업을 완료하여 더 많은 ${name2}을 획득하세요.",
    "Settings": "설정",
    "copyid": "아이디 복사",
    "UpgradeSuccessfully": "성공적으로 업그레이드",
    "Name": "이름",
    "userinfo": "사용자 정보",
    "disconnect": "연결 끊기",
    "Startmining": "채굴 시작",
    "Welcome": "{name}에 오신 것을 환영합니다",
    "Withdrawal": "출금",
    "Minimumamount": "최소 금액",
    "Networkfee": "네트워크 수수료",
    "Enteramount": "금액 입력",
    "Submit": "제출",
    "MinimumTip": "출금할 수 있는 금액이 너무 작습니다. 최소 출금 금액: {num}",
    "MaximumTip": "금액이 부족합니다. 출금할 수 있는 최대 금액은: {num}",
    "SubmittedTip": "제출되었습니다. 30-60 근무일 이내에 처리될 것으로 예상됩니다.",
    "WebSubmittedTip": "제출되었습니다. 24-48 시간 이내에 처리될 것으로 예상됩니다.",
    "WithdrawStatus": "상태",
    "Submissiontime": "제출 시간",
    "WithdrawAwaitTip": "* 처리에 30-60 근무일이 소요될 것으로 예상됩니다. 더 많은 친구를 초대하면 검토 프로세스를 빠르게 할 수 있습니다.",
    "WebWithdrawAwaitTip": "* 처리에 24-48 시간이 소요될 것으로 예상됩니다. 더 많은 친구를 초대하면 검토 프로세스를 빠르게 할 수 있습니다.",
    "Processing": "처리 중",
    "Success": "성공",
    "Rejection": "거절",
    "Amount": "금액",
    "Numberoffriends": "친구 수: {now}/{limit}",
    "InviteTip": "첫 출금을 하려면 {limit} 친구를 초대하여 채굴 앱에 가입시켜야 합니다.",
    "openonphone": "휴대폰에서 이 링크를 여세요.",
    "claimTip": "수령할 금액이 너무 작습니다. 최소 청구 금액은: {num}",
    "WalletBalance": "지갑 잔액",
    "Withdraw": "출금",
    "SetWalletAddress": "지갑 주소 설정",
    "WithdrawalRecord": "출금 기록",
    "Norecords": "기록 없음",
    "Whatis": "{name}는 무엇인가요?",
    "All": "모두",
    "save": "저장",
    "successWithdrawal": "출금이 수령되었습니다 {num}",
    "secondsago": "{time} 초 전에",
    "Loading": "로딩 중...",
    "PaymentConfirming": "거래 상태 확인 중...",
    "Check": "확인",
    "CheckFail": "거래가 완료되지 않았습니다. 5초 후에 다시 확인해 주세요.",
    "Addname": "'{name}'를 이름에 추가하세요",
    "Restattcheck": "앱을 재시작하여 확인하세요",
    "Copyname": "'{name}' 복사",
    "SubmissionFailed": "제출 실패, 나중에 다시 시도해 주세요",
    "WithdrawalReview": "출금 검토",
    "shop": "상점",
    "topurchase": "구매하기 위해 상점으로 이동",
    "shopDesc": "한정 수량—사라지기 전에 확보하세요!",
    "select_payment_method": "결제 방법 선택",
    "total_amount": "총 금액",
    "creating_order": "주문 생성 중...",
    "order_created": "주문이 생성되었습니다",
    "order_status": "주문 상태",
    "claim": "보상 수령",
    "payment_success": "결제 성공",
    "payment_failed": "결제 실패",
    "payment_cancelled": "결제 취소됨",
    "opening_payment": "결제 중...",
    "payment_status": "결제 상태",
    "create_order_failed": "주문 생성 실패",
    "creating_ton_order": "TON 주문 생성 중...",
    "next_step": "다음 단계",
    "use_ton_payment": "TON 결제 사용",
    "start_transaction": "거래 시작",
    "connect_wallet": "지갑 연결",
    "address": "주소",
    "amount_ton": "금액 TON",
    "copy": "복사",
    "amount": "금액",
    "wallet_address": "지갑 주소",
    "comment_memo": "댓글 메모",
    "you_can_choose_to_connect_wallet_to_pay": "결제를 위해 지갑을 연결할 수 있습니다",
    "or_manually_transfer_to_the_above_address": "또는 위 주소로 수동으로 이체할 수 있습니다(금액과 메모는 반드시 동일해야 합니다)",
    "transaction_success": "거래 성공",
    "transaction_failed": "거래 실패",
    "transaction_error": "거래 오류",
    "transaction_status": "거래 상태",
    "transaction_id": "거래 ID",
    "transaction_amount": "거래 금액",
    "transaction_status_desc": "거래 상태 설명",
    "payment_status_tip": "결제가 확인될 때까지 기다려 주세요",
    "Applyforwithdrawal": "출금 신청",
    "Withdrawalunlock": "출금 해제 중",
    "Close": "닫기",
    "Delivering": "배송 중",
    "Duetothelargenumber": "받는 사람이 많아 귀하의 에어드랍은 15-20 영업일 이내에 도착할 것으로 예상됩니다",
    "WithdrawalunlockTip": "출금을 해제하려면 {num}명의 초대된 친구가 필요합니다",
    "select_network": "네트워크 선택",
    "confirm": "확인",
    "switching_network": "네트워크 전환 중...",
    "network_switched": "네트워크 전환 완료",
    "use_usdt_payment": "USDT 결제 사용",
    "or_manually_transfer_to_the_above_address_usdt": "위 주소로 수동으로 전송하세요 (금액과 주소가 정확히 일치해야 함에 주의하세요)",
    "chain_type": "네트워크",
    "check_transaction_status": "거래 상태 확인",
    "transaction_wait": "거래가 처리 중입니다. 앱을 종료하셔도 됩니다. 완료되면 메시지가 알려드립니다.",
    "twa_pay_tip_with_memo": "전송을 위해 주소, 금액 및 메모가 일치하는지 확인해 주세요.",
    "twa_pay_tip": "전송을 위해 주소와 금액이 정확한지 확인해 주세요.",
    "creating_usdt_order": "USDT 주문 생성 중...",
    "affiliate_programs": "제휴 프로그램",
    "affiliate_programs_description": "친구를 초대하여 채굴 앱에 가입하고 보상을 받으세요.",
    "commission_details": "커미션 세부사항",
    "no_commission_records": "커미션 기록 없음",
    "commission_list": "커미션 목록",
    "input_amount": "입력 금액",
    "max": "최대",
    "commission_input_amount": "커미션 금액 입력",
    "min_commission": "최소 출금 금액은 {num}입니다.",
    "WithdrawalSuccess": "출금 성공",
    "WithdrawalFailed": "출금 실패",
    "WithdrawalProcessing": "출금 처리 중",
    "award": "보상",
    "level": "레벨",
    "Share_to_group": "그룹에 공유하기",
    "Exchange": "교환",
    "balance_not_enough": "잔액이 부족합니다. {num} {coin}만 교환할 수 있습니다.",
    "exchange_fail": "교환 실패",
    "exchange_success": "교환 성공",
    "you_will_receive": "받을 금액",
    "ShareToGroups": "그룹에 공유",
    "Numberofgroups": "그룹 수: {now}/{limit}",
    "Confirm": "확인",
    "ShareToGroupsDesc": "더 많은 {name}을(를) 얻으려면 그룹에 공유하세요.",
    "TokenAddress": "환출 세부정보를 입력하십시오. 예: 거래소 ID 또는 USDT 주소",
    "CashAddress": "환출 세부정보를 입력하십시오. 예: 은행 카드 번호 또는 USDT 주소",
    "Cancel": "취소",
    "min_withdrawal_amount": "최소 출금 금액은 {num} {coin}입니다.",
    "max_withdrawal_amount": "최대 출금 금액은 {num} {coin}입니다.",
    "withdrawal_failed": "출금 실패",
    "withdrawal_success": "출금 성공",
    "PayNow": "지금 결제하기",
    "PaySkip": "즉시 출금을 잠금 해제하려면 {num}을(를) 지불하십시오",
    "NumberofGroups": "그룹 수: {now}/{limit}",
    "SendMessage": "메시지 보내기",
    "NumberofShares": "공유 수: {now}/{limit}",
    "NumberofTasks": "작업 수: {now}/{limit}",
    "CompleteTask": "작업 완료",
    "PleaseEnterValidAmount": "유효한 금액을 입력해 주세요",
    "PleaseEnterValidEmail": "유효한 이메일을 입력해 주세요",
    "Feedback": "피드백",
    "Inputfeedbackcontent": "피드백 내용을 입력해 주세요",
    "Submitfeedback": "피드백 제출",
    "Pleaseenteravalidemailaddress": "유효한 이메일 주소를 입력해 주세요",
    "Pleaseenteryouremailaddress": "이메일 주소를 입력해 주세요",
    "Youhavealreadyfeedbackedtoday_pleasecomebacktomorrow": "오늘 이미 피드백을 제출하셨습니다. 내일 다시 와 주세요",
    "Feedback_submitted_successfully_thank_you_for_your_valuable_feedback": "피드백이 성공적으로 제출되었습니다. 소중한 피드백에 감사드립니다",
    "Feedback_submission_failed_please_retry": "피드백 제출에 실패했습니다. 다시 시도해 주세요",
    "ContactUs": "연락처",
    "XRPAddress": "활성화된 XRP 체인 지갑 주소(MEMO 포함)를 입력해 주십시오. 그렇지 않으면 현금을 인출할 수 없습니다.",
    "Accelerated": "가속화된",
    "Accelerated_withdrawals_success": "가속화된 출금이 성공적으로 이루어졌습니다",
    "login": "로그인",
    "register": "회원가입",
    "login_with_google": "Google로 로그인",
    "or": "또는",
    "email": "이메일",
    "password": "비밀번호",
    "no_account": "계정이 없으신가요",
    "click_to_go": "클릭하여",
    "have_account": "이미 계정이 있으신가요",
    "go_to": "이동하기",
    "invite_code": "초대 코드",
    "optional": "선택 사항",
    "google_login_not_ready": "Google 로그인이 준비되지 않았습니다. 나중에 다시 시도해 주세요",
    "password_too_long": "비밀번호가 너무 깁니다",
    "weak": "약함",
    "medium": "중간",
    "strong": "강함",
    "login_success": "로그인 성공",
    "login_failed": "로그인 실패",
    "please_input_email": "이메일을 입력해 주세요",
    "invalid_email": "잘못된 이메일 형식",
    "please_input_password": "비밀번호를 입력해 주세요",
    "password_length_6_to_16": "비밀번호는 6-16자여야 합니다",
    "account_or_password_error": "계정 또는 비밀번호 오류",
    "register_success": "회원가입 성공",
    "register_failed": "회원가입 실패",
    "save_error": "저장 오류, 나중에 다시 시도해주세요",
    "ShareToFriends": "친구에게 공유하기",
    "login_first": "먼저 로그인 해주세요",
    "WalletBscError": "❌ 유효하지 않은 BNB 체인 지갑 주소입니다.",
    "DownloadWallet": "지갑 다운로드",
    "AddToHomeScreen": "홈 화면에 {appName} 추가",
    "TapShareInToolbar": "툴바에서 탭",
    "SelectAddToHomeScreen": "홈 화면에 추가 선택",
    "OpenToolbar": "툴바 열기",
    "ClaimFailed": "보상이 실패했습니다. 나중에 다시 시도해 주세요",
    "guest_login": "게스트 로그인",
    "please_input_phone": "전화번호를 입력해주세요",
    "email_error_1": "이메일을 입력해주세요",
    "email_error_2": "유효한 이메일 주소를 입력해주세요",
    "email_error_3": "게스트 이메일은 허용되지 않습니다. 실제 이메일을 사용해주세요",
    "phone": "전화",
    "phone_error_1": "전화번호를 입력해주세요",
    "phone_error_2": "유효한 전화번호를 입력해주세요",
    "update_info": "정보 업데이트",
    "update_success": "업데이트 성공",
    "update_failed": "업데이트 실패, 나중에 다시 시도해주세요",
    "cancel": "취소",
    "guest_credentials_title": "계정 정보",
    "guest_credentials_warning": "계정과 비밀번호를 저장하려면 스크린샷을 찍어주세요. 분실 시, 수익을 복구할 수 없습니다!",
    "i_have_saved": "저장했습니다",
    "account": "계정",
    "view_credentials": "자격 증명 보기",
    "miner_max_reached": "이 마이너의 최대 수에 도달했습니다"
}};